import $ from "jquery";
import Cookies from "js-cookie";
import { fetch as fetchPolyfill } from "whatwg-fetch"; // one of the few things that still need separate polyfilling to core-js though they might still add support for it

import quilterFunctions from "../helpers/quilter-functions";
import utils from "../helpers/utils";
import regionsApp from "../app/regions-roles";

// On selects (mobile), we can't add the .js-region-leave to the option; check it on select event to toggle the leave prompt
const openRegionLeaveModal = (el, e, newHref) => {
  const targetModal = $(el).data("target");
  // When leaving region on mobile, new region needs to be passed in
  // We could find it by select's value, but data attr seems to work & is nicer to use
  const newOption = el.options[el.selectedIndex];
  const newRegionId = newOption.getAttribute("data-region-id");
  quilterFunctions.regionSelect(e, targetModal, newHref, newRegionId);
};

const toggleRegionModal = (dismissable = true) => {
  const $regionModal = $(".js-region-open");
  quilterFunctions.openModal(".js-region-open");

  // Required to proceed (not dismissable). Remove x, spacing & overlay functionality.
  // Ugh. This feels hacky.
  if (!dismissable) {
    $regionModal.removeClass("modal--has-x");
    $regionModal.find(".js-modal-overlay-closeable").removeClass("js-modal-overlay-closeable");
    $regionModal.find(".js-modal-close").remove();
  }

  regionsApp.init();
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const closeModal = () => {
  quilterFunctions.closeModal(".js-region-open");
};

const handleMissingRole = (regionId, isToggleRegionModal?: boolean) => {
  const localStorage = window.localStorage;

  if (regionId) {
    localStorage.setItem("newRegionId", regionId);
  }
  toggleRegionModal(isToggleRegionModal);
}

const handleToggleRegionModal = (roleId, regionId, dismissable?: boolean) => {
  const localStorage = window.localStorage;

  if (roleId) {
    localStorage.setItem("newRoleId", roleId);
  }
  if (regionId) {
    localStorage.setItem("newRegionId", regionId);
  }
  toggleRegionModal(dismissable);
}


const getCurrentRole = (roles: any[], roleId, selectVal) => {
  return roles.find((r) => r.RoleId === roleId || (selectVal && selectVal.includes(r.RoleId)));
}
const getCurrentRegion = (regions: any[], regionId, selectVal) => {
  return regions.find((r) => r.Id === regionId || (selectVal && selectVal.includes(r.Id)));
}

const handleOpenRegionLeaveModal = (el, e, newHref, preservedSelectedOption) => {
  // It's not a sibling, we need a warning!
  openRegionLeaveModal(el, e, newHref);

  if (preservedSelectedOption) {
    // Either keep the option selected or the actions of the user will lead to a new page
    preservedSelectedOption.selected = true;
  }
}

const handleOpenModalOnDemand = (currentRole, regionId, region, roleId, showPromptToAll, newHref) => {
  if (!regionId || !currentRole.Regions) return;

  // Toggle the modal to confirm change
  if (!!region && region.DisplayPrompt) {
    handleToggleRegionModal(roleId, regionId)
  }

    // Proceed to the link, no confirmation prompt required
    // As cookies will be set before we hit new url, no prompt will be shown
  // Unless we ask for confirmation on all changes (showPromptToAll)
  else if (!showPromptToAll) {
    Cookies.set("Region", regionId, {
      expires: 365,
      path: "/",
      secure: true,
    });
    Cookies.set("Role", roleId, {
      expires: 365,
      path: "/",
      secure: true,
    });
    window.open(newHref, "_top");
  } else {
    // Open the new region/role url, without setting the cookies, code detects a differnce, prompt will be shown
    window.open(newHref, "_top");
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const openModal = (el, e, preservedSelectedOption = null): void => {
  let regionId = el.getAttribute("data-region-id"); // select on mobile won't have the clicked regionId, we'd have the role href - work it out once we have the data
  let roleId = el.getAttribute("data-role-id"); // select on mobile won't have the roleId, we'd have the role href
  const apiUrl = el.getAttribute("data-api-url");
  const selectVal = el.value;
  const newHref = el.getAttribute("href") || selectVal; // link will have the href value, select will have the value set to the selected option (href)
  const warnOnLeave = el.getAttribute("data-warn-on-leave");
  const showPromptToAll = el.getAttribute("data-prompt-on-all") === "True";

  // if there are any temporary ids stored; remove them prior to starting the app
  localStorage.removeItem("newRoleId");
  localStorage.removeItem("newRegionId");

  // call the api
  fetchPolyfill(apiUrl)
    .then((res) => res.json())
    .then((res) => {
      if (!res || !res.UserRoles?.length) return;

      const roles = res.UserRoles;
      // find role / region by id or by select value
      const currentRole = getCurrentRole(roles, roleId, selectVal);

      if (!currentRole) {
        handleMissingRole(regionId)
        return; // don't try getting roles here if no roleId, no role = show the modal
      }

      const region = getCurrentRegion(currentRole.Regions, regionId, selectVal);

      roleId = roleId || currentRole ? currentRole.RoleId : null;
      regionId = regionId || region ? region.Id : null;

      // Stop! Do we need to confirm leaving of this region?
      const siblingRegionId = el.getAttribute("data-sibling-region-id");
      if (warnOnLeave === "True" && region?.Id !== siblingRegionId) {
        handleOpenRegionLeaveModal(el, e, newHref, preservedSelectedOption);
        return;
      }

      handleOpenModalOnDemand(currentRole, regionId, region, roleId, showPromptToAll, newHref);
    })
    // console.log the err as any errors within previous f() won't get shown in the console by default
    .catch((err) => console.log("2. error fetching or showing roles & regions data: ", err));
};

const fetchRolesAndRegions = async (apiUrl: string, roleId: string, regionId: string, forceOpen: boolean) => {
  try {
    const res = await fetch(apiUrl);
    const data = await res.json();
    if (!data || !data.UserRoles?.length) return;

    const roles = data.UserRoles;
    // find role / region by id or by select value
    const currentRole = roles.find((r) => r.RoleId === roleId);

    if (!currentRole) {
      handleMissingRole(regionId, false);  // answer is required; not dismissable
      return; // don't try getting roles here if no roleId, no role = show the modal
    }

    const region = currentRole?.Regions.find((r) => r.Id === regionId);

    if (!region) return;

    if (forceOpen || region.DisplayPrompt) {
      handleToggleRegionModal(roleId, regionId, false);
    }
  } catch(error) {
    console.log("3. error fetching or showing roles & regions data: ", error);
  }
}

const openModalOnLoad = async () => {
  // Show this if
  // or hasn't seen cookie message
  if (!$(".js-region-open").length) {
    // "no regions");
    return;
  }

  const apiUrl = $(".js-region-open").data("apiUrl");
  const cookieSeenPolicyLink = utils.convertToBoolean(Cookies.get("SeenCookieMessage"));
  const civicCookieEnabled = utils.convertToBoolean($(".js-region-open").data("enableCookieScript"));
  const hasSeenCivicCookie = !!Cookies.get("SavedCivicCookies");

  // Get Role & Region of fthe url params and if they don't match, show the prompt
  // The prompt will have to contain the role and region from the Url not from the cookies even if they don't match
  const urlRegionId = utils.getUrlParameter("Region");
  const urlRoleId = utils.getUrlParameter("Role");
  // Do not show prompt when params don't match cookies, but we want to ignore this. This happens when user just switches role/region.
  // const ignoreRoleRegion = utils.getUrlParameter("ignoreRoleRegion");
  const storedRegionId = localStorage.getItem("newRegionId");
  const storedRoleId = localStorage.getItem("newRoleId");
  const cookieRegionId = Cookies.get("Region");
  const cookieRoleId = Cookies.get("Role");
  const currRegionId = storedRegionId || cookieRegionId;
  const currRoleId = storedRoleId || cookieRoleId;
  const regionDiffers = urlRegionId && urlRegionId !== currRegionId;
  const roleDiffers = urlRoleId && urlRoleId !== currRoleId;
  const urlDiffersFromStorage = regionDiffers || roleDiffers;

  // If URL params exist and differ → update localStorage to reflect new state
  if (urlDiffersFromStorage) {
    if (urlRoleId) {
      localStorage.setItem("newRoleId", urlRoleId);
    }
    if (urlRegionId) {
      localStorage.setItem("newRegionId", urlRegionId);
    }
  }

  const showModal =
    urlDiffersFromStorage ||
    !cookieSeenPolicyLink ||
    !currRegionId ||
    !currRoleId ||
    (civicCookieEnabled && !hasSeenCivicCookie);

  if (!showModal) {
    return;
  }

  await fetchRolesAndRegions(apiUrl, urlRoleId || currRoleId, urlRegionId || currRegionId, urlDiffersFromStorage);
};

async function init() {
  const regionLeaveEl = document.querySelectorAll<HTMLElement>(".js-region-leave"); // faux-dropdown version
  const regionSwitchEl = document.querySelectorAll<HTMLSelectElement>(".js-region-switch"); // mobile/ <select> version

  // Work out whether or not show modal on load within the function
  await openModalOnLoad();

  // In theory regionLeaveEl & regionSwitchEl _could_ conflict with each other.
  // Client is aware, but wants those as they are as they would not add conflicting data
  regionLeaveEl.forEach(regEl =>
  {
    regEl.onclick = (e) =>
      {
        const targetDropdown = regEl.getAttribute("data-target");
        const newHref = regEl.getAttribute("href");
        // set the new cookie in region select - pass new region id
        const newRegionId = regEl.getAttribute("data-region-id");
        if (targetDropdown && newHref) {
          quilterFunctions.regionSelect(e, targetDropdown, newHref, newRegionId);
        }
      };
  });

  regionSwitchEl.forEach(regEl =>
  {
    if (regEl.dataset.isSelect) {
      const preservedSelectedOption = regEl.options ? regEl.options[regEl.options.selectedIndex] : null;
      // tslint:disable-next-line: only-arrow-functions
      regEl.onchange = function(e)
        {
          openModal(this, e, preservedSelectedOption);
        };
    } else {
      // tslint:disable-next-line: only-arrow-functions
      regEl.onclick = function(e)
        {
          openModal(this, e);
          e.preventDefault();
        };
    }
  });
}

export default { init };
export { closeModal, openModal };
